import MainHeader from './MainHeader.vue';

export default MainHeader;



// WEBPACK FOOTER //
// ./src/pages/profile/components/mainheader/index.ts